import React from "react";
import { Field, reduxForm } from "redux-form";
import { Form, FormGroup } from "react-bootstrap";
import { VERIFY_ACCOUNT_FORM } from "../../../../actions/user.actions";

import Button from "../../../../components/common/button/Button";
import Input from "../../../../components/common/input/Input";
import Error from "../../../../components/common/error/Error";
import {
  required,
  creditCard,
  numeric,
  cardExpDate
} from "../../../../utils/forms/validators";

import styles from "./CompanyPaymentAddCard.scss";

const isCreditCardNum = creditCard("Please use a valid credit card number");
const numberMsg = numeric("This Field must be a number");
const isCardExpDate = cardExpDate(
  "The expiration date does not match the format MM/YY."
);

class CompanyPaymentAddCard extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      handleSubmit,
      submitting,
      invalid,
      pristine,
      revalidateField,
      revalidate: { number, name, ccv, expiration_date }
    } = this.props;

    return (
      <section className={styles.section}>
        <div className={styles.content}>
          <h2 className={styles.title}>Add New Card</h2>

          <Form className={styles.form} onSubmit={handleSubmit}>
            <FormGroup className={styles.formGroup}>
              <Field
                name="number"
                type="text"
                placeholder="Credit Card Number"
                forceError={
                  this.props.forceError != null && !number ? true : false
                }
                onChange={revalidateField}
                component={Input}
                validate={[required, isCreditCardNum]}
              />

              <Field
                name="name"
                type="text"
                placeholder="Name on Card"
                forceError={
                  this.props.forceError != null && !name ? true : false
                }
                onChange={revalidateField}
                component={Input}
                validate={[required]}
              />

              <Field
                name="ccv"
                type="text"
                formGroupClassName={styles.shortInput}
                forceError={
                  this.props.forceError != null && !ccv ? true : false
                }
                onChange={revalidateField}
                placeholder="CCV"
                component={Input}
                validate={[required, numberMsg]}
              />

              <Field
                name="expiration_date"
                type="text"
                formGroupClassName={styles.shortInput}
                forceError={
                  this.props.forceError != null && !expiration_date
                    ? true
                    : false
                }
                onChange={revalidateField}
                placeholder="Exp. Date"
                component={Input}
                validate={[required, isCardExpDate]}
              />
            </FormGroup>
            <Button
              isPrimary
              type="submit"
              size={"large"}
              label="Add New Card"
              isDisabled={invalid || submitting || pristine}
            />

            <Error />
          </Form>
        </div>
      </section>
    );
  }
}

export default (CompanyPaymentAddCard = reduxForm({
  form: VERIFY_ACCOUNT_FORM
})(CompanyPaymentAddCard));



// WEBPACK FOOTER //
// ./src/routes/employer/payment/components/CompanyPaymentAddCard.js